<template>
  <div>
    <h2>{{ $t("views.devices.detail.title") }}</h2>

    <entity-detail-table
      :entityKey="eParent.key"
      :entityId="eParent.id"
      :readOnly="$store.getters['profile/isReadOnlyTenant'](entity.tenantId)"
      @control:input="onInput"
      @control:change="onChange"
      @entity:save="onSave"
    />
  </div>
</template>

<script>
import MixinEntityBase from "@/components/mixins/EntityBase";
import EntityDetailTable from "@/components/entity/DetailTable";

export default {
  name: "Devices.Detail",
  mixins: [MixinEntityBase],
  components: {
    EntityDetailTable,
  },
  computed: {
    entity() {
      return (this.$store.getters[`${this.eParent.key}/getEntity`](this.eParent.id) || {}).value || {};
    },
    prices() {
      if (
        this.entityParent == null ||
        this.entityParent.value == null ||
        this.entityParent.value.prices == null ||
        this.entityParent.value.prices.length === 0
      ) {
        return [];
      }
      return this.entityParent.value?.prices[0]?.datas;
    },
  },
  methods: {
    onInput(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onChange(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onSave(entity) {
      this.$store.dispatch(`${this.eParent.key}/updateEntity`, entity);
    },
  },
};
</script>

<style lang="scss"></style>
